import { dashboard, travelInsurance, support, users, agencyDetails } from './agencyAdmin';
import {
    BritamAdminAgencies,
    BritamAdminHomeItem,
    BritamAdminProducts,
    BritamAdminUsers,
    BritamAdminTravelInsurance,
    Adminsupport
} from './britam-admin';
import { getAgencyLocalTravelStatus, retrieveEncryptedData } from '../Application/utils/AppSessionStorage';
import {
    BritamUnderwriteAgencies,
    BritamUnderwriteHomeItem,
    BritamUnderwriteProducts,
    Underwritersupport,
    UnderwriteTravelInsurance
} from './underwirter';
import { BritamISCAgencies, BritamISCHomeItem, BritamISCProducts, ISCsupport, ISCTravelInsurance } from './isc';
import { BritamCSEBDAgencies, BritamCSEBDHomeItem, BritamCSEBDProducts, CSEBDTravelInsurance, CSEsupport } from './cse-bd';

// Retrieve the role from session storage
const roleName = retrieveEncryptedData();

const agencyLocalTravelStatus = getAgencyLocalTravelStatus();

// Define menu items based on role
const menuItems = {
    items:
        roleName === 'ROLE_ADMINISTRATOR'
            ? [BritamAdminHomeItem, BritamAdminTravelInsurance, BritamAdminProducts, BritamAdminAgencies, BritamAdminUsers, Adminsupport]
            : roleName === 'ROLE_REGIONAL_ADMIN'
              ? [BritamAdminHomeItem, BritamAdminTravelInsurance, BritamAdminProducts, BritamAdminAgencies, BritamAdminUsers, Adminsupport]
              : roleName === 'ROLE_AGENCY_ADMIN'
                ? agencyLocalTravelStatus
                    ? [dashboard, travelInsurance, agencyDetails, users, support]
                    : [dashboard, travelInsurance, users, support]
                : roleName === 'ROLE_AGENT' || roleName === 'ROLE_BRANCH_MANAGER'
                  ? agencyLocalTravelStatus
                      ? [dashboard, travelInsurance, agencyDetails, support]
                      : [dashboard, travelInsurance, support]
                  : roleName === 'ROLE_UNDER_WRITER'
                    ? [
                          BritamUnderwriteHomeItem,
                          UnderwriteTravelInsurance,
                          BritamUnderwriteProducts,
                          BritamUnderwriteAgencies,
                          Underwritersupport
                      ]
                    : roleName === 'ROLE_ISC'
                      ? [BritamISCHomeItem, ISCTravelInsurance, BritamISCProducts, BritamISCAgencies, ISCsupport]
                      : roleName === 'ROLE_CSE'
                        ? [BritamCSEBDHomeItem, CSEBDTravelInsurance, BritamCSEBDProducts, BritamCSEBDAgencies, CSEsupport]
                        : []
};

export default menuItems;
